// deps
import React, { useMemo } from "react";

// components
import PaymentGroupTitle from "../components/Title";
import PaymentGroupContainer from "../components/Container";
import PayLater from "@payment-ui/components/payment-method/pay-later";

// helpers
import { isEmpty } from "@swiggy-private/payment-core";
import {
    isPaymentMethodSelected,
    getPaymentMethods,
    generatePaymentMethodId,
    getPaymentGroupDisplayName,
    isPaymentGroupEnabled,
    getPaymentGroupDisableMessage,
    getPaymentGroupIconUrl,
} from "@payment-ui/helpers/Payment";

// interfaces
import { IPayLaterPaymentGroup } from "@payment-ui/interfaces/PayLater";

// test-ids
import { PAYMENT_GROUP_TEST_IDS } from "@swiggy-private/payment-test-ids";
import styles from "../PaymentGroup.v4.scss";

export default function PayLaterPaymentGroup(props: IPayLaterPaymentGroup): JSX.Element | null {
    const { isFrictionPage } = props;
    const paymentMethods = useMemo(() => getPaymentMethods(props), [props]);
    const isGroupEnabled = useMemo(() => isPaymentGroupEnabled(props.paymentData), [props.paymentData]);

    if (isEmpty(paymentMethods)) {
        return null;
    }

    return (
        <PaymentGroupContainer isFrictionPage={isFrictionPage}>
            {!props.hideGroupTitle && (
                <PaymentGroupTitle
                    title={getPaymentGroupDisplayName(props.paymentData)}
                    disableMessage={getPaymentGroupDisableMessage(props.paymentData)}
                    data-testid={PAYMENT_GROUP_TEST_IDS.TITLE.PAY_LATER}
                    groupIcon={getPaymentGroupIconUrl(props.paymentData)}
                />
            )}
            <div className={styles.paymentGroupContainer}>
                {paymentMethods.map(paymentMethod => {
                    const id = generatePaymentMethodId(paymentMethod);
                    return (
                        <PayLater
                            key={paymentMethod.displayName}
                            id={id}
                            paymentAmount={props.paymentAmount}
                            user={props.user}
                            methodData={paymentMethod}
                            isPaymentGroupEnabled={isGroupEnabled}
                            paymentActions={props.paymentActions}
                            selected={isPaymentMethodSelected(props.selectedPaymentId, id)}
                        />
                    );
                })}
            </div>
        </PaymentGroupContainer>
    );
}
